export enum ServiceTypeEnum {
  POSTPAID = 'postpaid',
  PREPAID = 'prepaid',
  MIX = 'mix',
  INTERNET = 'internet',
}

